import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { computed, ref } from 'vue'
import RankingChart from '@/views/dashboard/_components/ranking-chart/ranking-chart.vue'
import { TimeRange } from '@/views/dashboard/_components/time-range-select/time-range.enum'

interface ClassificationItem {
  name: string
  percentage: number
}


export default /*#__PURE__*/_defineComponent({
  __name: 'online-classification-chart',
  props: {
    data: { default: () => [] },
    timeRange: { default: TimeRange.DAYS_30 }
  },
  emits: ["update:timeRange"],
  setup(__props: any, { expose: __expose, emit: __emit }) {

const props = __props

const emit = __emit

const loading = ref(false)
const timeRange = computed({
  get: () => props.timeRange,
  set: (val) => emit('update:timeRange', val)
})

const classificationData = computed(() => {
  return props.data.map(item => ({
    name: item.name,
    count: item.percentage
  }))
})

__expose({
  loading
})

return (_ctx: any,_cache: any) => {
  const _component_el_tag = _resolveComponent("el-tag")!

  return (_openBlock(), _createBlock(RankingChart, {
    title: _ctx.$t('accessRestriction.onlineClassTop5'),
    data: classificationData.value,
    "show-time-range": true,
    "time-range": timeRange.value,
    "onUpdate:timeRange": [
      _cache[0] || (_cache[0] = ($event: any) => ((timeRange).value = $event)),
      _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('update:timeRange', $event)))
    ],
    loading: loading.value,
    "onUpdate:loading": _cache[1] || (_cache[1] = ($event: any) => ((loading).value = $event)),
    unit: "%",
    "name-key": "name"
  }, {
    titleAfter: _withCtx(() => [
      _createVNode(_component_el_tag, {
        size: "small",
        type: "primary"
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t('common.rankTagTop5')), 1)
        ]),
        _: 1
      })
    ]),
    "count-text": _withCtx(({ item }: any) => [
      _createTextVNode(_toDisplayString((item as any).percentage || item.count) + "% ", 1)
    ]),
    _: 1
  }, 8, ["title", "data", "time-range", "loading"]))
}
}

})